import { Component } from '@angular/core';

@Component({
  selector: 'app-office-departments-portal',
  templateUrl: './office-departments-portal.component.html',
  standalone: false,
})
export class OfficeDepartmentsPortalComponent {}
